import React, { type ReactNode } from 'react';

import './_YatLinkForm.scss';

type Props = {
    children: ReactNode;
    isLink: boolean;
    href: string;
};

export default function YatLinkForm({ children, isLink, href }: Props) {
    return isLink ? (
        <a className="YatFormLink" href={href} target="_blank" rel="noopener noreferrer nofollow">
            <div className="YatForm">{children}</div>
        </a>
    ) : (
        <div className="YatForm">{children}</div>
    );
}
